export default __webpack_public_path__ + "static/media/uploader-ascensiaContourNextMeter-problem-1.0ce0b860.png";